import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import { useAppSelector } from "../../../../../store/hooks/StoreHooks";
import { createChart2 } from "../../../../../utilities/commonUtilities";
import HeadCurve from "./HeadCurve";

interface Props { }

const HeadCurves: React.FC<Props> = () => {
  const headChartRef = useRef<HTMLDivElement | null>(null);
  const [chart2Config, setChart2Config] = useState<any>([]);
  const { Chart2Data } = useAppSelector(state => state?.pump);
  const { isReports } = useAppSelector((state) => state?.reports);

  useEffect(() => {
    if (Chart2Data?.length > 0) {
      setChart2Config(createChart2(Chart2Data));
    }
  }, [Chart2Data]);

  const efficiencyChartDownload = () => {
    if (headChartRef.current) {
      html2canvas(headChartRef.current, {
        backgroundColor: "#384252",
      }).then((canvas) => {
        const imgUrl = canvas.toDataURL("image/png");

        const link = document.createElement("a");
        link.href = imgUrl;
        link.download = "Head-Curves.png";
        link.click();
      });
    }
  };

  return (
    <>
      {" "}
      <div className="flex justify-between mt-[16px] p-4">
        <div></div>
        {!isReports && <div className="flex">
          <button
            onClick={efficiencyChartDownload}
            className="ml-[16px] border-[1px] border-solid border-[#4A5463] py-[8px] px-[14px] inline-flex justify-center items-center gap-[8px] rounded-[8px] bg-transparent text-neutral-25"
          >
            Export head curve
          </button>
        </div>}
      </div>
      <div className="mb-[15px] pt-[30px]" ref={headChartRef}>
        <HeadCurve chart2Data={chart2Config} />
      </div>
    </>
  );
};

export default HeadCurves;
